import { translations } from '../../../translations'

export const RejectOrdersModal = {
  icon: 'close-circle',
  title: translations.pt_PT.Modal.titleRejectOrder,
  footerBtn: 'saveBtn',
  component: 'rejectOrders'
}



// WEBPACK FOOTER //
// ./src/skeletons/structures/setup/rejectOrdersModal.js